import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import en from "./en";
import bm from "./bm";

const DICTS = { en, bm };
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("nexus-lang") || "en");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("nexus-lang", l);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang === "bm" ? "ms" : "en";
  }, [lang]);

  const t = useCallback(
    (path) => {
      const resolve = (dict) =>
        path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), dict);
      return resolve(DICTS[lang]) ?? resolve(DICTS.en) ?? path;
    },
    [lang]
  );

  const pick = useCallback((field) => (field && typeof field === "object" ? field[lang] ?? field.en : field), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
